<template>
        <div class="banner-timer" v-if="show">
            <div class="timer">
                <div class="banner-timer-left">
                    <div class="banner-timer-text">
                        Сегодня — <span>{{today.weekday}}</span>, {{today.date}}
                    </div>
                    <div class="banner-timer-text">
                        Рынок закрыт и откроется в понедельник.
                    </div>
                </div>
                <div class="banner-timer-right">
                    <div class="banner-timer-text">
                        До открытия рынка
                    </div>
                    <div class="banner-timer-text">
                        <span>{{viwerTimer.days}} дней {{viwerTimer.hours}}:{{viwerTimer.minutes}}:{{viwerTimer.seconds}}</span>
                    </div>
                </div>
                <div class="banner-timer-close" @click = "closeBanner" >
                    <i class="icon-close"></i>
                </div>
            </div>
            <div class="switchEndWeekWidget">
                <i @click="showOrHideEndWeekWidget" 
                    :class="showEndWeekWidget ? 'icon-icon-up' : 'icon-icon-down'">
                </i>
            </div>
            <div v-if="showEndWeekWidget" class="endWeekData">
                <endWeeksWidget />
            </div>
        </div>
</template>
<script>
import endWeeksWidget from "./endWeeksWidget"
export default {
    components: {
        endWeeksWidget
    },
    data() {
        return {
            interval:null,
            viwerTimer:{},
            show:true,
            showEndWeekWidget:false
        }
    },
    computed: {
        today() {
            let nowDate = new Date();
            let today = {
                weekday: nowDate.toLocaleString('ru',{ weekday: 'long'}),
                date: this.$datef(nowDate,'d')
            }
            return today;
        }
    },
    methods: {
        setTime(days, hours, minutes, seconds) {
            this.viwerTimer = {
                days:days,
                hours:hours,
                minutes:minutes,
                seconds:seconds
            }
        },
        getTimer () {
            let nowDate = new Date();
            let countDownDate = null;
            if(nowDate.getDay() == 6) 
                countDownDate  = new Date(nowDate.getFullYear(),nowDate.getMonth(), nowDate.getDate() + 2).getTime();
            else
                countDownDate = new Date(nowDate.getFullYear(),nowDate.getMonth(), nowDate.getDate() + 1).getTime();
            this.interval = setInterval(() => {
                let now = new Date().getTime();
                let distance = countDownDate - now;
                let days = Math.floor(distance / (1000 * 60 * 60 * 24));
                let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                let minutes = ('0' + Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))).slice(-2);
                let seconds = ('0' + Math.floor((distance % (1000 * 60)) / 1000)).slice(-2);
                this.setTime(days,hours,minutes,seconds);
                if (distance < 0) {
                    clearInterval(this.interval);
                    this.show = false;
                }
            }, 1000);
        },
        closeBanner() {
            this.show = false;
        },
        showOrHideEndWeekWidget() {
            this.showEndWeekWidget = !this.showEndWeekWidget;
        }
    },
    created() {
        this.getTimer()
    }
}
</script>
<style lang="less" scoped>
.timer {
    display: flex;
    width: 100%;
    justify-content: space-between;
}
.switchEndWeekWidget {
    width: 100%;
    text-align: center;
    margin-top: 23px;
}
.banner-timer {
    position: absolute;
    z-index: 99;
    left: 0;
    right: 0;
    margin: 0 auto;
    top:200px;
    border-radius: 4px;
    background-color: rgb(255, 254, 204);
    padding: 20px 24px;
    font-family: Roboto;
    font-size: 14px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.43;
    letter-spacing: 0.4px;
    color:#293546;
    width:600px;
    span {
        font-weight: bold;
    }
    &-close {
        cursor: pointer;
        font-size: 16px;
        display: flex;
        align-items: center;
    }
}
</style>

